// MUI
import { Box, Stack, Typography } from "@mui/material"

// Next Image
import Image from "next/image"

// Icons
import Lock from "public/images/icons/lock.svg"
import User from "public/images/icons/user.svg"
import MobileSvg from "public/images/icons/mobile-message.svg"

// --------------------------------------------|| AUTH HEADER - COMPONENTS ||----------------------------------------------------

const AuthHeader = props => {
  const { page, title, subTitle } = props
  return (
    <Box sx={{ mt: 2 }}>
      <Stack direction='row' justifyContent='center' mb={1}>
        <Image width={70} src={page === "login" ? Lock : User} alt='mobile' priority />
      </Stack>
      <Typography textAlign='center' fontWeight='bold' variant='h5' color='primary'>
        {title}
      </Typography>
      <Typography textAlign='center' variant='subtitle2' color='textSecondary' mt={0.5}>
        {subTitle}
      </Typography>
    </Box>
  )
}

export default AuthHeader
